























import Vue from 'vue'
import { mapState } from 'vuex'
import style from './style.module.scss'

import config from '@/config'

import { FileModel } from '@/types/common'

import fileInput from '@/components/controls/file-input/file-input.vue'

export default Vue.extend({
    name: 'file',
    components: {
        fileInput
    },
    props: {

    },
    data() {
        return {
            style: style,
            config: config
        }
    },
    methods: {
        setFiles(data: File) {
            this.$store.dispatch('updateFiles', data);
        },
        deleteFile(index: number) {
            this.$store.dispatch('deleteFile', index);
            (this.$refs.fileInput as any).deleteFile(index);
        }
    },
    computed: {
        ...(mapState<RootStateSupplierSearch>({
            files(state: RootStateSupplierSearch): FileModel[] {
                return state.currentProject.Additional.Files || [];
            },
        }) as MapStateToComputed<RootStateSupplierSearch>)
    }
})
